import { Injectable } from '@angular/core';
import { RESTService } from 'src/app/common/services/rest.service'
import { HttpParams } from '@angular/common/http';
import { PaymentPlanDefaults } from '../model/payment-plan';

@Injectable({
    providedIn: 'root'
})
export class OperationService {
    constructor(private restService: RESTService) { }
     
    // Wallet =======================================================================

    stepone(username: any, transactionId: any, steponeRequest: any) {
        let parameters = new HttpParams().set(RESTService.REQUEST_PARAM_CUSTOMER_USERNAME, username).set(RESTService.REQUEST_PARAM_TRANSACTION_ID, transactionId);
        return this.restService.post_(RESTService.API_WALLET_STEP_ONE, parameters, steponeRequest);
    }

    stepthree(tokenId: string) {
        let parameters = new HttpParams().set("token-id", tokenId);
        return this.restService.get(RESTService.API_WALLET_STEP_THREE, parameters);
    }

    walletEdit(transactionId: string, body: any) {
        let parameters = new HttpParams().set(RESTService.REQUEST_PARAM_TRANSACTION_ID, transactionId);
        return this.restService.put(RESTService.API_WALLET, parameters, body);
    }

    addWallet(transactionId: string, body: any) {
        //debugger;
        let parameters = new HttpParams().set(RESTService.REQUEST_PARAM_TRANSACTION_ID, transactionId);
        return this.restService.post_(RESTService.API_WALLET, parameters, body);
    }
  
    wallets(transactionId: string) {
        let parameters = new HttpParams().set(RESTService.REQUEST_PARAM_TRANSACTION_ID, transactionId);
        return this.restService.get(RESTService.API_WALLET, parameters);
    }

    deleteWallet(transactionId: string, sid: any) {
        let parameters = new HttpParams().set(RESTService.REQUEST_PARAM_TRANSACTION_ID, transactionId).set(RESTService.REQUEST_PARAM_SID, sid);
        return this.restService.delete(RESTService.API_WALLET, parameters);
    }

    // End Wallet =======================================================================

    // Rule =======================================================================

    frequencies(isAutoPay) {
        let parameters = new HttpParams().set(RESTService.REQUEST_PARAM_TRANSACTION_ID, localStorage.getItem(PaymentPlanDefaults.CONSTANT_TRANSACTION_ID)).set("type", isAutoPay ? 'A' : 'P');
        return this.restService.get("/frequency", parameters)
    }

    rule(transactionId: string, body: any) {
        let parameters = new HttpParams().set(RESTService.REQUEST_PARAM_TRANSACTION_ID, transactionId);
        return this.restService.put(RESTService.API_RECURRING, parameters, body);
    }

    rules(transactionId: string) {
        let parameters = new HttpParams().set(RESTService.REQUEST_PARAM_TRANSACTION_ID, transactionId);
        return this.restService.get(RESTService.API_RECURRING, parameters);
    }

    deleteRule(transactionId: string, sid: any) {
        let parameters = new HttpParams().set(RESTService.REQUEST_PARAM_SID, sid).set(RESTService.REQUEST_PARAM_TRANSACTION_ID, transactionId);
        return this.restService.delete(RESTService.API_RECURRING, parameters);
    }

    // End Rule =======================================================================

    //payment-operation
    paymentDefaults(transactionId: string, sid: any) {
        let parameters = new HttpParams().set(RESTService.REQUEST_PARAM_SID, sid).set(RESTService.REQUEST_PARAM_TRANSACTION_ID, transactionId);
        return this.restService.get(RESTService.API_PAYMENT_DEFAULTS, parameters);
    }

    payment(transactionId: string, body: any) {
        //debugger;
        let parameters = new HttpParams().set(RESTService.REQUEST_PARAM_TRANSACTION_ID, transactionId);        
        return this.restService.post_(RESTService.API_PAYMENT, parameters, body);
    }

    customPay(transactionId: string, body: any) {
        let parameters = new HttpParams().set(RESTService.REQUEST_PARAM_TRANSACTION_ID, transactionId);
        return this.restService.post_(RESTService.API_PAYMENT_CUSTOMPAY, parameters, body);
    }

    paymentPay(transactionId: string, sid: any, body: any) {
        //debugger;
        let parameters = new HttpParams().set(RESTService.REQUEST_PARAM_SID, sid).set(RESTService.REQUEST_PARAM_TRANSACTION_ID, transactionId);
        return this.restService.post_(RESTService.API_PAYMENT_PAY, parameters, body);
    }

     findPendingPayments(accountId: string, billingId: string, locationId: string) {
        let parameters = new HttpParams().set(RESTService.REQUEST_PARAM_ACCOUNT_ID, accountId).set(RESTService.REQUEST_PARAM_BILLING_ID, billingId).set(RESTService.REQUEST_PARAM_LOCATION_ID, locationId);
        return this.restService.get(RESTService.API_PENDING_PAYMENTS, parameters);
    }

    cancelScheduledAutopayments(billingId: string, ruleId: string, body: any) {
    let parameters = new HttpParams().set(RESTService.REQUEST_PARAM_BILLING_ID, billingId).set(RESTService.REQUEST_PARAM_RULEID, ruleId);
    return this.restService.put(RESTService.API_SCHEDULED_AUTO_PAYMENTS, parameters, body);
    }

}
